// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1EU9R","disabled":"FileBtn_disabled__ChKB7","warn":"FileBtn_warn__1Z7L7","fade":"FileBtn_fade__1WApJ"};